module.exports = __webpack_public_path__ + "static/media/iranyekanwebmediumfanum.fe2e65f0.ttf";